module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (205).9bdaab95.jpg";